(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "../../services/api"], b);else if ("undefined" != typeof exports) b(exports, require("../../services/api"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.api), a.index = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b) {
  "use strict";

  var c = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = a.ApiProvider = void 0, b = c(b);

  var d = function d(_ref) {
    var a = _ref.host,
        c = _ref.children;
    return b.default.host = a, c;
  };

  a.ApiProvider = d;
  a.default = d;
});